import { render, staticRenderFns } from "./FilterSidebar.vue?vue&type=template&id=afbd957a"
import script from "./FilterSidebar.vue?vue&type=script&lang=js"
export * from "./FilterSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentyaboktober/65379/65/Stoffe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afbd957a')) {
      api.createRecord('afbd957a', component.options)
    } else {
      api.reload('afbd957a', component.options)
    }
    module.hot.accept("./FilterSidebar.vue?vue&type=template&id=afbd957a", function () {
      api.rerender('afbd957a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/stoffe/FilterSidebar.vue"
export default component.exports